import { getBasicDeviceInfo } from 'src/utils/platform';

// Kept free of casrjs imports so callers can check support without pulling in
// the onnxruntime chunk.
export const isPlatformSupported = (): boolean => {
  const info = getBasicDeviceInfo();
  return info.device_type !== 'mobile' && info.device_type !== 'tablet';
};
